import React, { useContext } from 'react';
import { INode, INodeProps } from '@/types/node';
import { Theme, useTheme } from '@mui/material/styles';
import { getSpacerValue } from '@/lib/utils/format';
import { IContent } from './contract';
import { useNodeProps } from '@/node-editor/hooks';
import { MarkdownRender } from '@/components/markdown/markdownRender';
import { AuthContext } from '@/store';
import { Box } from '@mui/material';

interface INodeExtended extends Omit<INode, 'content'> {
  content: IContent;
}

interface IProps extends Omit<INodeProps, 'node'> {
  node: INodeExtended;
}

/**
 * Embed Node description...
 */
export const Render = ({
  node: {
    id,
    override,
    content: { text, alignment, verticalSpacing },
  },
}: IProps) => {
  const theme = useTheme();
  const { authState } = useContext(AuthContext);

  const markdownContainerSx = {
    width: '100%',
    textAlign:
      alignment.horizontal === 'flex-start'
        ? 'left'
        : alignment.horizontal === 'flex-end'
        ? 'right'
        : alignment.horizontal,
    paddingTop: theme.spacing(getSpacerValue(verticalSpacing.top)),
    paddingBottom: theme.spacing(getSpacerValue(verticalSpacing.bottom)),
    ...override?.root,
  };

  return (
    <Box {...useNodeProps(id)} sx={markdownContainerSx}>
      <MarkdownRender text={text} templateData={authState.user} />
    </Box>
  );
};
